import cx from 'classnames';
import PropTypes from 'prop-types';

import { InviteUserIcon } from 'src/assets/icons/InviteUser';
import { TrialUsageMeters } from 'src/components/TrialUsageMeters';
import { FEATURE_LIMITS } from 'src/data/featureLimits';
import { TRACK_EVENT_SOURCE } from 'src/lib/events';
import { useIsCustomerLocked } from 'src/services';
import { useCurrentCustomer, useCurrentProjectId, useCustomFeatureLimitsData } from 'src/store';
import { InviteUsersButton } from 'src/views/InviteUsersButton';
import { ViewSubscriptionStatus } from 'src/views/ViewSubscriptionStatus';

import { BookDemoButton } from './BookDemoButton';
import { UserProfile } from './UserProfile';
import { useStyles } from './useStyles';

export const TopNavigationBarItems = ({ className, light }) => {
  const styles = useStyles();
  const isCustomerLocked = useIsCustomerLocked();
  const currentCustomer = useCurrentCustomer();
  const currentProjectId = useCurrentProjectId();
  const predictionsLimitsData = useCustomFeatureLimitsData(FEATURE_LIMITS.performancePredictions);

  return (
    <div className={cx(styles.root, className, { [styles.light]: light })}>
      <InviteUsersButton
        className={styles.inviteButton}
        startIcon={<InviteUserIcon />}
        source={TRACK_EVENT_SOURCE.navbar}
      />
      <BookDemoButton />
      <TrialUsageMeters
        currentCustomer={currentCustomer}
        currentProjectId={currentProjectId}
        predictionsLimitsData={predictionsLimitsData}
      />
      <ViewSubscriptionStatus />
      <UserProfile disabledSettings={isCustomerLocked} />
    </div>
  );
};

TopNavigationBarItems.propTypes = {
  className: PropTypes.string,
  light: PropTypes.bool,
};
TopNavigationBarItems.defaultProps = {
  className: null,
  light: false,
};
